import { sceneItems } from "@/mocks/news";

export default function Scene() {
  const [lead, ...rest] = sceneItems;

  return (
    <section id="scene" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-live-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              我们在现场
            </span>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">现场直击</h2>
          </div>
          <span className="hidden text-sm text-foreground-500 sm:inline-flex items-center gap-1.5">
            <i className="ri-map-pin-2-line text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            实时定位更新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {/* lead card */}
          <article className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <div className="relative overflow-hidden">
              <img src={lead.image} alt={lead.title} className="aspect-[16/10] w-full object-cover transition-transform duration-300 group-hover:scale-105" />
              <span className="absolute left-4 top-4 rounded-full bg-background-950/70 px-3 py-1 text-xs text-white backdrop-blur">
                {lead.tag}
              </span>
              <div className="absolute bottom-4 left-4 flex items-center gap-2">
                <span className="flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                  <i className="ri-map-pin-2-fill w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true"></i>
                  {lead.place}
                </span>
              </div>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="text-lg font-bold leading-snug text-foreground-950">
                <a href="#scene" className="hover:text-primary-600">{lead.title}</a>
              </h3>
              <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">{lead.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
                <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true"></i>
                发布于 {lead.date}
              </span>
            </div>
          </article>

          {/* side cards */}
          <div className="flex flex-col gap-5">
            {rest.map((s) => (
              <article key={s.id} className="group flex overflow-hidden rounded-2xl border border-background-200 bg-background-100">
                <div className="relative w-2/5 shrink-0 overflow-hidden">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
                </div>
                <div className="flex flex-1 flex-col justify-center p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1 rounded-full bg-background-200 px-2.5 py-0.5 font-medium text-foreground-800">
                      <i className="ri-map-pin-2-line w-3 h-3 flex items-center justify-center" aria-hidden="true"></i>
                      {s.place}
                    </span>
                    <span>{s.date}</span>
                  </div>
                  <h3 className="mt-2.5 text-[15px] font-semibold leading-snug text-foreground-950 md:text-base">
                    <a href="#scene" className="hover:text-primary-600">{s.title}</a>
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{s.excerpt}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}